module.exports = __webpack_public_path__ + "static/media/UNIe.4c9ffaec.png";